import React from "react";
import { FinalisationProvider } from "src/pages/finalisation/FinalisationContext";
import FinalisationForm from "src/pages/finalisation/form/FinalisationForm";
import { gererRedirectSecurite } from "src/app/api/AppApiClient";
import { useAppState } from "src/app/state/StateProvider";
import { useAsync } from "react-async-hook";
import { getUser } from "src/app/api/FinalizationApi";
import AppSpinner from "src/commun/composants/AppSpinner/AppSpinner";
import AppMessage from "src/commun/composants/AppMessage/AppMessage";
import { useAppText } from "src/commun/composants/AppText";

export type FinalisationProps = {
  shortId: string | null;
};

const FinalisationCompte = ({ shortId }: FinalisationProps) => {
  const [{ user }] = useAppState();
  const { tString } = useAppText();

  if (!shortId && !user) {
    gererRedirectSecurite();
  }

  const userToFinalize = useAsync(getUser, [shortId]);

  if (userToFinalize.status === "loading") {
    return <AppSpinner animation="grow" />;
  }

  return (userToFinalize.status === "success" && userToFinalize.result) ? (


    (userToFinalize.result.userMigre) ? (
      <div style={{display:"flex", justifyContent:"center", width:"600"}}>
      <AppMessage messageType="ERROR" children={<>{tString("migration.erreur.compte.deja.finalise")}</>} />
      </div>

    ) : (
      <FinalisationProvider shortId={shortId} userToFinalize={userToFinalize.result}>
        <FinalisationForm />
      </FinalisationProvider>
    )

    ) : (
      <div style={{ width: "100%", marginBottom: "10px" }}>
        <AppMessage messageType="ERROR" children={<>{tString("error.technical")}</>} />
      </div>
    );

};

export default FinalisationCompte;